import { PAPER_SIZES } from 'src/config';
import { PaperSize } from 'src/types';
import { twMerge } from 'tailwind-merge';

interface PaperSizeSelectorProps {
  selectedSize: PaperSize;
  onSelect: (size: PaperSize) => void;
  testIdPrefix?: string;
}

export function PaperSizeSelector({
  selectedSize,
  onSelect,
  testIdPrefix = 'paper-size',
}: PaperSizeSelectorProps) {
  const paperSizes: PaperSize[] = ['A1', 'A2', 'A3', 'A4'];

  return (
    <div className="w-full">
      <label className="mb-2 block text-sm font-medium text-gray-700">
        Paper Size
      </label>
      <div className="grid grid-cols-2 gap-2">
        {paperSizes.map((size) => {
          const paperInfo = PAPER_SIZES[size];
          return (
            <button
              key={size}
              type="button"
              onClick={() => onSelect(size)}
              className={twMerge([
                'rounded-md border-2 p-3 text-left transition-all',
                selectedSize === size
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-300 hover:border-gray-400',
              ])}
              data-testid={`${testIdPrefix}-${size}`}
            >
              <div className="font-semibold">{size}</div>
              <div className="text-xs text-gray-500">
                {paperInfo.width} × {paperInfo.height} mm
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
